/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HttpMethod/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function HttpMethod({
  children,
  viewPath = "/DesignSystem/ApiCaller/Request/HttpMethod",
  onChange
  
}) {
let httpMethodsValueData = fromData.useDataValue({ viewPath,
context: 'http_methods',
})
let apiReqMethodValueData = fromData.useDataValue({ viewPath,
context: 'api',
path: 'req.method',
})
let apiReqMethodChangeData = fromData.useDataChange({ viewPath,
context: 'api',
path: 'req.method',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginRight={dtSpaceXxs}
 marginTop={0}
 alignItems="stretch"
 maxWidth="100px"
 allowEmptyChoice={false}
 data="http_methods"
 from={httpMethodsValueData}
 data="api.req.method"
 value={apiReqMethodValueData}
 onChange={apiReqMethodChangeData}
 size="small"
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}